// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/admin_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DeleteAnnounceMediaArgs, DeleteAnnounceMediaReply, UploadAnnounceMediaArgs, UploadAnnounceMediaReply } from "./announce_media_service_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { ChangePasswordArgs, ChangePasswordReply, CreateAdminUserWithPasswordArgs, CreateAdminUserWithPasswordReply, LoginAdminArgs, LoginAdminReply, UpdateAdminUserProfileArgs, UpdateAdminUserProfileReply } from "./auth_service_pb";
import { GetUnreadContactCountArgs, GetUnreadContactCountReply, MarkContactAsReadArgs, MarkContactAsReadReply, MarkContactAsUnreadArgs, MarkContactAsUnreadReply } from "./contact_service_pb";
import { AdminAddCompositeIndexArgs, AdminAddCompositeIndexReply, AdminAddIndexArgs, AdminAddIndexReply, AdminDropColumnArgs, AdminDropColumnReply, AdminDropCompositeIndexArgs, AdminDropCompositeIndexReply, AdminDropIndexArgs, AdminDropIndexReply } from "./db_migration_service_pb";
import { AdminHealthCheckArgs, AdminHealthCheckReply } from "./health_check_admin_service_pb";
import { PublishStagingToProductionArgs, PublishStagingToProductionReply } from "./publish_service_pb";
import { DeleteResultMediaArgs, DeleteResultMediaReply, UploadResultCategoryThumbnailArgs, UploadResultCategoryThumbnailReply, UploadResultMediaArgs, UploadResultMediaReply } from "./result_media_service_pb";

/**
 * AdminServiceサービス定義
 *
 * @generated from service service.AdminService
 */
export const AdminService = {
  typeName: "service.AdminService",
  methods: {
    /**
     * @generated from rpc service.AdminService.UploadAnnounceMedia
     */
    uploadAnnounceMedia: {
      name: "UploadAnnounceMedia",
      I: UploadAnnounceMediaArgs,
      O: UploadAnnounceMediaReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.DeleteAnnounceMedia
     */
    deleteAnnounceMedia: {
      name: "DeleteAnnounceMedia",
      I: DeleteAnnounceMediaArgs,
      O: DeleteAnnounceMediaReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.LoginAdmin
     */
    loginAdmin: {
      name: "LoginAdmin",
      I: LoginAdminArgs,
      O: LoginAdminReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.ChangePassword
     */
    changePassword: {
      name: "ChangePassword",
      I: ChangePasswordArgs,
      O: ChangePasswordReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.CreateAdminUserWithPassword
     */
    createAdminUserWithPassword: {
      name: "CreateAdminUserWithPassword",
      I: CreateAdminUserWithPasswordArgs,
      O: CreateAdminUserWithPasswordReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.UpdateAdminUserProfile
     */
    updateAdminUserProfile: {
      name: "UpdateAdminUserProfile",
      I: UpdateAdminUserProfileArgs,
      O: UpdateAdminUserProfileReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.GetUnreadContactCount
     */
    getUnreadContactCount: {
      name: "GetUnreadContactCount",
      I: GetUnreadContactCountArgs,
      O: GetUnreadContactCountReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.MarkContactAsRead
     */
    markContactAsRead: {
      name: "MarkContactAsRead",
      I: MarkContactAsReadArgs,
      O: MarkContactAsReadReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.MarkContactAsUnread
     */
    markContactAsUnread: {
      name: "MarkContactAsUnread",
      I: MarkContactAsUnreadArgs,
      O: MarkContactAsUnreadReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.DropColumn
     */
    dropColumn: {
      name: "DropColumn",
      I: AdminDropColumnArgs,
      O: AdminDropColumnReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.AddIndex
     */
    addIndex: {
      name: "AddIndex",
      I: AdminAddIndexArgs,
      O: AdminAddIndexReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.DropIndex
     */
    dropIndex: {
      name: "DropIndex",
      I: AdminDropIndexArgs,
      O: AdminDropIndexReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.AddCompositeIndex
     */
    addCompositeIndex: {
      name: "AddCompositeIndex",
      I: AdminAddCompositeIndexArgs,
      O: AdminAddCompositeIndexReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.DropCompositeIndex
     */
    dropCompositeIndex: {
      name: "DropCompositeIndex",
      I: AdminDropCompositeIndexArgs,
      O: AdminDropCompositeIndexReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.HealthCheck
     */
    healthCheck: {
      name: "HealthCheck",
      I: AdminHealthCheckArgs,
      O: AdminHealthCheckReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.PublishStagingToProduction
     */
    publishStagingToProduction: {
      name: "PublishStagingToProduction",
      I: PublishStagingToProductionArgs,
      O: PublishStagingToProductionReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.UploadResultMedia
     */
    uploadResultMedia: {
      name: "UploadResultMedia",
      I: UploadResultMediaArgs,
      O: UploadResultMediaReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.DeleteResultMedia
     */
    deleteResultMedia: {
      name: "DeleteResultMedia",
      I: DeleteResultMediaArgs,
      O: DeleteResultMediaReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc service.AdminService.UploadResultCategoryThumbnail
     */
    uploadResultCategoryThumbnail: {
      name: "UploadResultCategoryThumbnail",
      I: UploadResultCategoryThumbnailArgs,
      O: UploadResultCategoryThumbnailReply,
      kind: MethodKind.Unary,
    },
  }
} as const;

